module.exports = __webpack_public_path__ + "img/17.f10baf30.png";